import { IconPlus } from "@tabler/icons-react";
import {
  Button,
  Typography,
  Textarea,
  Label,
  Card,
  CardContent,
} from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { Turn } from "./testCaseFormTypes";

interface TurnsSectionProps {
  turns: Turn[];
  allowTurnManagement: boolean;
  onChange: (turns: Turn[]) => void;
}

export const TurnsSection: React.FC<TurnsSectionProps> = ({
  turns,
  allowTurnManagement,
  onChange,
}) => {
  const addTurn = () => {
    onChange([...turns, { user_message: "", expected_ai_response: "" }]);
  };

  const removeTurn = (index: number) => {
    onChange(turns.filter((_, i) => i !== index));
  };

  const updateTurn = (index: number, field: keyof Turn, value: string) => {
    const newTurns = [...turns];
    newTurns[index] = { ...newTurns[index], [field]: value };
    onChange(newTurns);
  };

  return (
    <div>
      <Typography variant="body" size="sm" weight="medium" className="al-mb-2 al-block">
        Turns
      </Typography>

      {turns.map((turn, index) => (
        <div key={index}>
          <Card className="al-mb-3">
            <CardContent className="al-pt-4">
              <Stack direction="row" justify="between" align="center" className="al-mb-2">
                <Typography variant="body" size="sm" weight="medium">
                  Turn {index + 1}
                </Typography>
                {allowTurnManagement && turns.length > 1 && (
                  <Button onClick={() => removeTurn(index)} size="sm" variant="destructive">
                    Remove
                  </Button>
                )}
              </Stack>

              <div className="al-mb-3">
                <Label htmlFor={`user-message-${index}`} className="al-mb-1 al-block">
                  <Typography
                    variant="body"
                    size="xs"
                    weight="medium"
                    className="al-text-orange-700 al-uppercase"
                  >
                    User Message
                  </Typography>
                  <Textarea
                    id={`user-message-${index}`}
                    className="al-mt-1 al-border-orange-200 al-bg-orange-50 focus:al-border-orange-300 focus:al-ring-orange-100"
                    rows={3}
                    value={turn.user_message}
                    onChange={e => updateTurn(index, "user_message", e.target.value)}
                    placeholder="Enter the user's question or message..."
                  />
                </Label>
              </div>

              <div>
                <Label htmlFor={`expected-response-${index}`} className="al-mb-1 al-block">
                  <Typography variant="body" size="xs" weight="medium" className="al-text-teal-700 al-uppercase">
                    Expected AI Response
                  </Typography>
                  <Textarea
                    id={`expected-response-${index}`}
                    className="al-mt-1 al-border-teal-200 al-bg-teal-50 focus:al-border-teal-300 focus:al-ring-teal-100"
                    rows={3}
                    value={turn.expected_ai_response}
                    onChange={e => updateTurn(index, "expected_ai_response", e.target.value)}
                    placeholder="Describe the expected AI response..."
                  />
                </Label>
              </div>
            </CardContent>
          </Card>
        </div>
      ))}

      {allowTurnManagement && (
        <Stack direction="row" justify="center">
          <Button onClick={addTurn} size="sm" type="button">
            <IconPlus className="al-w-4 al-h-4 al-mr-2" />
            Add Turn
          </Button>
        </Stack>
      )}
    </div>
  );
};
